<div class="container">
  <div class="heading-container">
    <p class="heading" i18n>Invite New User</p>
    <button class="close-btn" (click)="onCancel()" aria-label="Close dialog">×</button>
  </div>

  <form class="form-body" [formGroup]="inviteForm" (ngSubmit)="onSubmit()">
    <app-input
      [inputStyle]="'popup-form-field'"
      [required]="true"
      [formCntlName]="name"
      [inputType]="textInputType"
      [label]="nameLabel"
      [placeholder]="namePlaceholder"
    >
    </app-input>
    @if (name.hasError('required') && name.touched) {
      <div class="mat-error-msg" i18n>Name is required</div>
    }
    @if (name.hasError('whitespace') && name.touched) {
      <div class="mat-error-msg">Input cannot be just spaces.</div>
    }
    @if (name.hasError('maxlength')) {
      <div class="mat-error-msg" i18n>Name cannot exceed 256 characters</div>
    }

    <app-input
      [inputStyle]="'popup-form-field'"
      [required]="true"
      [formCntlName]="email"
      [inputType]="emailInputType"
      [label]="emailLabel"
      [placeholder]="emailPlaceholder"
    >
    </app-input>
    @if (email.hasError('required') && email.touched) {
      <div class="mat-error-msg" i18n>Email is required</div>
    }
    @if (email.hasError('whitespace') && email.touched) {
      <div class="mat-error-msg">Input cannot be just spaces.</div>
    }
    @if (email.hasError('email')) {
      <div class="mat-error-msg" i18n>Please enter a valid email</div>
    }

    <app-input
      [inputStyle]="'popup-form-field'"
      [required]="true"
      [formCntlName]="phone"
      [inputType]="textInputType"
      [label]="phoneLabel"
      [placeholder]="phonePlaceholder"
    >
    </app-input>
    @if (phone.hasError('required') && phone.touched) {
      <div class="mat-error-msg" i18n>Phone number is required</div>
    }
    @if (phone.hasError('whitespace') && phone.touched) {
      <div class="mat-error-msg">Input cannot be just spaces.</div>
    }
    @if (phone.hasError('pattern')) {
      <div class="mat-error-msg" i18n>Please enter a valid phone number</div>
    }
  </form>

  <div class="footer-actions">
    <app-buttons
      [name]="'Cancel'"
      [arialLabel]="arialLabel"
      [buttonType]="btnMat"
      [buttonStyle]="btnStyleText"
      (buttonClickEvent)="onCancel()"
    >
    </app-buttons>

    <app-buttons
      [isDisabled]="inviteForm.invalid || isSubmitting"
      [name]="'Send Invite'"
      [buttonType]="btnMatFlat"
      [buttonStyle]="inviteForm.invalid ? btnStyleFilledSmallDisabled : btnStyleFilledSmall"
      (buttonClickEvent)="onSubmit()"
    ></app-buttons>
  </div>
</div>
